import moment from "moment-timezone";
const useFormatMoney = () => {
  const currency = process.env.VUE_APP_CURRENCY || 'CZK';
  const locale = currency === 'EUR' ? 'sk-SK' : 'cs-CZ';
  const isEur = currency === 'EUR';
  return (value) => {
    const numValue = isEur ? (Number.parseFloat(value) || 0) : (Number.parseInt(value) || 0);
    return numValue.toLocaleString(locale, {
      style: "currency",
      currency: currency,
      minimumFractionDigits: isEur ? 2 : 0,
      maximumFractionDigits: isEur ? 2 : 0,
    });
  };
};

const useFormatDate = () => {
  return (value) => {
    return new Date(value).toLocaleDateString("cs-CZ");
  };
};

const useFormatDayMonth = () => {
  return (value) => {
    return moment(new Date(value)).tz('Europe/Prague').format('D. M.');
  };
};

const useFormatDateTime = () => {
  return (value) => {
    return moment(new Date(value)).format("D. M. HH:mm");
  };
};

const useFormatTime = () => {
  return (value) => {
    return moment(new Date(value)).tz('Europe/Prague').format('HH:mm');
  };
};

const useFormatAddress = () => {
  return (user) => {
    return (
      (user.street || "") +
      " " +
      (user.house_number || "") +
      ", " +
      (user.city || "") +
      ", " +
      (user.zip_code || "")
    );
  };
};

const useFormatTermLength = () => {
  return (term) => {
    return moment.duration(moment(term.to).diff(moment(term.from))).asMinutes();
  };
};

export {
  useFormatMoney,
  useFormatDate,
  useFormatDateTime,
  useFormatAddress,
  useFormatTermLength,
  useFormatTime,
  useFormatDayMonth,
};
